import { AddContractSolicitor } from "../features/contract/add-contract-solicitoe/add-contract-solicitor";

const Addcontractsolicitior = () => {
  return <AddContractSolicitor />;
};

export default Addcontractsolicitior;
